var map = {
	"./26691-removebg-preview.png": 7802,
	"./Coin in Hand.png": 4176,
	"./Family_Registration.png": 3562,
	"./SocialMedia/Facebook.png": 2129,
	"./SocialMedia/Instagram Old.png": 937,
	"./SocialMedia/Pinterest.png": 7534,
	"./SocialMedia/Twitter.png": 986,
	"./SocialMedia/female.png": 35,
	"./SocialMedia/male.png": 7430,
	"./Transaction.png": 7038,
	"./back-button.png": 2957,
	"./budget.png": 1891,
	"./bugdev.png": 7852,
	"./card.png": 3393,
	"./charity-icon.png": 8231,
	"./charity-jar.png": 5774,
	"./charity.png": 5959,
	"./coming_soon.png": 749,
	"./delete-icon.png": 2464,
	"./delete.png": 1125,
	"./dollar.png": 9134,
	"./dropdown.png": 6711,
	"./edit-icon.png": 8971,
	"./education-support.png": 8448,
	"./fingerPrint.png": 5002,
	"./fingerPrint2.png": 2449,
	"./food.png": 6283,
	"./h15-2.png": 4852,
	"./health-support.png": 4364,
	"./health.png": 3833,
	"./home.png": 6553,
	"./icons8-charity-80.png": 4091,
	"./kwf-logo.png": 3899,
	"./location.png": 6780,
	"./login.png": 9520,
	"./man.png": 4612,
	"./map.png": 3808,
	"./mastercard.png": 6010,
	"./medicalStore.png": 3623,
	"./partner/likemindedlogo.png": 3121,
	"./partner/partner-10.png": 8983,
	"./partner/partner-2.png": 2042,
	"./partner/partner-3.png": 9081,
	"./partner/partner-5.png": 7457,
	"./partner/partner-6.png": 3019,
	"./partner/partner-7.png": 7194,
	"./partner/partner-9.png": 1504,
	"./paypal.png": 4165,
	"./ration-support.png": 6571,
	"./shapes/black-star.png": 4508,
	"./shapes/childern-icon.png": 2062,
	"./shapes/food-icon.png": 6645,
	"./shapes/gray-star.png": 6673,
	"./shapes/green-arrow.png": 9464,
	"./shapes/green-star.png": 5513,
	"./shapes/left-green-arrow.png": 1301,
	"./shapes/orphan-icon.png": 3974,
	"./upload-file.png": 9427,
	"./visacard.png": 882,
	"./why-content.png": 5621,
	"./woman.png": 7020,
	"./world.png": 7883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;